import { defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';
import type { Address } from '../types/address';
import type { Household } from '../types/household';
import type { StepOwnerData } from '../types/step-data';
import useOrderStore from './order';

const useFormOwnerStore = defineStore('form-owner', () => {
  const orderStore = useOrderStore();

  const ownerType = ref<boolean>(true);
  const addressIsConnectionAddress = ref<boolean>(false);
  const household = ref<Household>();
  const address = ref<Address>();

  const stepData = computed<StepOwnerData>(() => ({
    isOwner: ownerType.value === true,
    isManager: ownerType.value === false,
    household: household.value!,
    isClientsAddress: addressIsConnectionAddress.value,
    address: addressIsConnectionAddress.value ? orderStore.ordererData!.address : address.value!,
  }));

  watch(addressIsConnectionAddress, value => {
    if (value) {
      address.value = undefined;
    } else {
      address.value = {
        street: '',
        houseNumber: '',
        suffix: '',
        zipCode: '',
        city: '',
      };
    }
  });

  return {
    address,
    addressIsConnectionAddress,
    household,
    ownerType,
    stepData,
  };
});

export default useFormOwnerStore;
